import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-items: center;
  width: 100%;
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize}rem`};
  font-weight: ${props => props.theme.fontWeight};
  padding: ${props => props.theme.padding};
  cursor: default;
  &:empty {
    padding: 0;
  }
`;
